import { render, staticRenderFns } from "./ApprovalAttendanceRemote.vue?vue&type=template&id=31513b8f"
import script from "./ApprovalAttendanceRemote.vue?vue&type=script&lang=js"
export * from "./ApprovalAttendanceRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports